import {
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  QueryList,
  Sanitizer,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { UtilService } from 'src/app/services/util.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaymentService } from 'src/app/services/payment.service';
import * as introJs from 'intro.js/intro.js';
import { formatNumber } from '@angular/common';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import {
  SchoolModuleBatch,
  SchoolModuleEvent,
} from 'src/app/models/module/moduledetails';
import {
  FeatureGroups,
  SchoolViewModel,
} from 'src/app/models/school/schooladminitem.model';
import { ScormService } from 'src/app/services/scorm.service';

declare const $: any;

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
})
export class ModuleDetailsComponent implements OnInit, OnDestroy {
  isFetchingData: boolean;
  //addAdminError: string;
  //addMessage: string;

  moduleInfo: any = {};
  tutorList: any = [];
  users: any;
  lessons: any;
  currentUserIsAdmin;
  showModulePane: boolean = false;
  schoolName: string;
  schoolID: number;
  adminActions: AdminAction[];
  lessonurlparam;
  currentUserIsStudent: any;
  moduledescription: SafeHtml = '';
  notauser: any;
  passCourse: boolean = false;
  userenrolled: boolean;
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  @ViewChild('paymentIframe') paymentIframe: ElementRef;
    @ViewChild('welcometextfrominvitemail') welcometextfrominvitemail: ElementRef;
  windowMessageReceivedHandler;
  moduleID: any;
  enrolFileName: string;
  scromFileName: string;
  modulePackageNames: any[] = [];
  introJS = introJs();
  toursteps: any[] = [];
  modulelogourl: string;
  paymentWindow: Window;
  allowTutorSendMail: boolean = false;
  allowBatches: boolean = false;
  enableCompleteButton: boolean = false;
  showCompleteButton: boolean = false;
  moduleCompleted: boolean = false; //so that it won't show the button by default
  courseEvent: Array<SchoolModuleEvent> = [];
  selectedBatchId: number = 0;
  moduleBatches: SchoolModuleBatch[] = [];
  canViewLessons: boolean = false;
  enrollText = 'Enroll For Course';
  fromDashboard: boolean;
  school: SchoolViewModel = new SchoolViewModel();
  progress = 0;
  scorePercentage = 0;
  passScorePercentage = 0;
  passed = false;
  enrolledDate: any;
  constructor(
    public useraccessservice: UseraccessserviceService,
    public headerinfo: ComponentheaderService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    public modulemanager: ModulemanagementService,
    private toastr: ToastrService,
    public util: UtilService,
    public sanitizer: DomSanitizer,
    private schoolservice: SchoolmanagementService,
    private payments: PaymentService,
    private scormService: ScormService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    headerinfo.setHeaderDisplay('Loading Course...', [], []);
    this.windowMessageReceivedHandler = this.windowMessageReceived.bind(this);
    this.toursteps = [
      {
        element: '#coursedescription',
        intro: 'Course description appears here',
        position: 'right',
      },
      {
        element: '#moduleaccessdays',
        intro: 'The number of days the course is available to the participants',
        position: 'left',
      },
      {
        element: '#moduletutors',
        intro:
          'Course tutors appear in this scetion. Click their avatars to view details of the tutors',
        position: 'left',
      },
      {
        element: '#modulecurri',
        intro:
          'The course lessons appears here in the order which they are to be taken.<br/> The <i >&uarr;</i> button is used to move a lesson postion up and the <i class="fa fa-arrow-down"></i> moves the lesson position down',
        position: 'left',
      },
    ];
    this.introJS.setOptions({
      steps: this.toursteps,
      showProgress: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      skipLabel: 'Exit',
    });
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.windowMessageReceivedHandler);
  }

  async windowMessageReceived(event) {
    //debugger;
    if (event.data.type == 'paymentdone') {
      if (event.data.responsecode == '0') {
        this.toastr.success('Payment Successful');
        await this.getModuleInfo();
      } else {
        if (isNaN(event.data.responsecode)) {
          this.toastr.error(event.data.reason, 'Payment Error', {
            timeOut: 0,
            closeButton: true,
          });
        } else {
          this.toastr.warning(event.data.reason, 'Payment Processing...', {
            timeOut: 0,
            closeButton: true,
          });
        }
      }
      this.closePaymentWindow();
    }
  }

  async ngOnInit() {
    this.school = this.util.schoolInfoBundle.schoolInfo;
    window.addEventListener('message', this.windowMessageReceivedHandler);    
    try {
      await this.getModuleInfo();

      const fromParam = this.activatedroute.snapshot.queryParamMap.get('from');
      if (fromParam == 'enrollnow' && this.moduleInfo.price <= 0 && !this.userenrolled && this.moduleInfo.requireEnrollment)
        await this.submtEnroll();

      if (fromParam == 'invitemail' || (fromParam == 'enrollnow' && !this.moduleInfo.allowBatches))
        $(this.welcometextfrominvitemail.nativeElement).modal('show');
      if(fromParam == 'enrollnow' && this.moduleInfo.allowBatches && this.moduleInfo.price > 0)
        $(this.welcometextfrominvitemail.nativeElement).modal('show');
    } 
    catch (error) {
      console.error(error);
      this.toastr.error('An error occured while loading the course');
      if (this.useraccessservice.getCurrentUserToken()) 
        this.router.navigate(['user/dashboard']);
      else 
        this.router.navigate(['site/schoolhome']);      
    }
  }

  async getModuleInfo() {
    this.moduleID = this.activatedroute.snapshot.queryParams.moduleID;
    this.fromDashboard = this.activatedroute.snapshot.queryParams.dash ?? false;
    this.lessonurlparam = { moduleid: this.moduleID };
    this.isFetchingData = true;
    this.headerinfo.pageLoadingStarted(this);
    const [data, schooldetails, modulePackageNames]: any = await Promise.all([
      this.modulemanager.getModuleDetails(this.moduleID).toPromise(),
      this.schoolservice.getSchoolDetails().toPromise(),
      this.modulemanager.getModulePackageNames(this.moduleID).toPromise(),
    ]);

    if (this.useraccessservice.loggedIn()) {
      this.modulemanager.getUpcomingModuleInvites(this.moduleID,0).then((data) => {
        this.courseEvent = data;
      });
    }

    this.modulePackageNames = modulePackageNames;
    // (data: any) => {
    this.moduleInfo = data.moduleinfo; 
    // this.modulelogourl= this.moduleInfo.logo+ '?' +  (new Date()).getTime();
    this.modulelogourl = this.moduleInfo.logo;
    this.moduledescription = this.sanitizer.bypassSecurityTrustHtml(
      this.moduleInfo.description
    );
    this.enrolledDate = data.enrollDate;
    this.canViewLessons = data.canViewLessons;
    this.tutorList = data.tutors;
    this.currentUserIsAdmin = data.isViewerAdmin;
    this.currentUserIsStudent = data.isViewerStudent;
    this.notauser = data.isNotUser;
    this.lessons = data.lessons;
    this.users = data.users;
    this.progress = data.progressPercentage;
    this.isFetchingData = false;
    this.moduleCompleted = data.completed;
    this.scorePercentage = data.scorePercentage;
    this.passScorePercentage = data.passScorePercentage;
    this.passed = data.passed;  
    this.enableCompleteButton = data.enableCompleteButton;
    this.showCompleteButton = data.showCompleteButton;
    this.allowBatches = data.allowBatches;
    //this.addAdminError = null;
    this.schoolName = data.schoolName;
    this.schoolID = data.schoolID;
    let stdBatch = data.studentBatchId ?? 0;
    if (this.moduleInfo.allowBatches && this.moduleInfo.nextBatchDate) {
      this.enrollText = 'Enroll for next batch';
    }

    let displayName = this.moduleInfo.name;
    if (this.moduleInfo.courseCode) {
      displayName += ` (${this.moduleInfo.courseCode})`;
    }
    //debugger;
    if (this.currentUserIsAdmin) {
      this.adminActions = [
        {
          displaytext: 'Add Lesson',
          route: '/user/editlesson',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-plus'],
        },
        {
          displaytext: 'Edit Course',
          route: '/user/editmodule',
          params: { moduleID: this.moduleID },
          classes: ['fa', 'fa-edit'],
        },
        {
          displaytext: 'Import Course SCORM',
          callback: this.openScormModal.bind(this),
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-file-import'],
        },
        {
          displaytext: 'Media Library',
          route: '/user/modulemedialibrary',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-photo-video'],
          disabled: !(await this.util.hasFeature(FeatureGroups.MEDIA_LIBRARY)),
          featureGroup: FeatureGroups.MEDIA_LIBRARY,
        },
        {
          displaytext: 'Manage Tutors',
          route: '/user/manageadminusers',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-users'],
        },     
        {
          displaytext: 'View all Assessments',
          route: '/user/allassessments',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-tasks'],
          disabled: !(await this.util.hasFeature(FeatureGroups.ASSESSMENTS)),
          featureGroup: FeatureGroups.ASSESSMENTS,
        },
        {
          displaytext: 'View Activity Log',
          route: '/activity/logs',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fas', 'fa-list'],
        },
        {
          displaytext: 'Enroll Students from Excel',
          callback: this.openenrolmodal.bind(this),
          classes: ['fas', 'fa-upload'],
          disabled: !(await this.util.hasFeature(
            FeatureGroups.STUDENT_BULK_UPLOAD
          )),
          featureGroup: FeatureGroups.STUDENT_BULK_UPLOAD,
        },
        {
          displaytext: 'Delete Course',
          callback: this.popconfirmdelete.bind(this),
          classes: ['fas', 'fa-trash'],
        },
        {
          displaytext: 'Manage Events',
          route: '/events/view',
          params: { moduleID: this.moduleInfo.id },
          classes: ['fas', 'fa-calendar'],
          disabled: !(await this.util.hasFeature(FeatureGroups.EVENTS)),
          featureGroup: FeatureGroups.EVENTS,
        },
        {
          displaytext: 'View all Registered Students',
          route: '/user/modulestudentlist',
          params: { moduleid: this.moduleInfo.id },
          classes: ['fa', 'fa-street-view'],
        }
      ];
      
      if(this.moduleInfo?.requireEnrollment){
        this.adminActions.push(
          {
            displaytext: 'View Unregistered Students',
            route: '/user/unregisteredstudents',
            params: { moduleid: this.moduleInfo.id },
            classes: ['fa', 'fa-user-slash'],
          },
          {
            displaytext: 'Invite Students',
            route: '/user/invitestudent',
            params: { moduleid: this.moduleInfo.id },
            classes: ['fas', 'fa-users'],
          },
          {
            displaytext: 'Add a School Student',
            route: '/user/addstudent',
            params: { moduleid: this.moduleInfo.id },
            classes: ['fas', 'fa-user'],
          }
        );
      }
      
      //schooldetails = await this.schoolservice.getSchoolDetails().toPromise();
      this.allowTutorSendMail = schooldetails.schoolInfo.tutorCanSendMail;

      if (this.allowTutorSendMail) {
        this.adminActions.push({
          displaytext: 'Send Email',
          route: '/user/sendmail',
          params: { moduleId: this.moduleInfo.id },
          classes: ['fas', 'fa-envelope'],
          disabled: !(await this.util.hasFeature(
            FeatureGroups.NOTIFICATIONS_EMAILS
          )),
          featureGroup: FeatureGroups.NOTIFICATIONS_EMAILS,
        });
      }

      if (this.allowBatches) {
        this.adminActions.push({
          displaytext: 'Batches',
          route: '/user/modulebatches',
          params: { moduleID: this.moduleInfo.id },
          classes: ['fas', 'fas fa-th-large'],
        });
      }
    } else {
      this.adminActions = [];
    }

    if (
      this.currentUserIsStudent &&
      this.allowBatches &&
      stdBatch <= 0 &&
      this.fromDashboard &&
      this.moduleInfo.nextBatchDate
    ) {
      this.popBatches();
      this.canViewLessons = false;
    }
    this.headerinfo.setHeaderDisplay(
      displayName,
      [
        { displaytext: 'School', route: `schoolhome` },
        {
          displaytext: 'Course',
          route: this.activatedroute.snapshot.url.join('/'),
          params: this.activatedroute.snapshot.queryParams,
        },
      ],
      this.adminActions,
      this.toursteps
    );
    this.userenrolled =
      this.currentUserIsAdmin || this.currentUserIsStudent || this.notauser;

    // if (this.currentUserIsStudent && !this.passCourse && this.showBadge) {
    //   this.toastr.warning(`You did not meet the minimum passing score of ${this.moduleInfo.passScorePercentage}%`);
    // }
    this.addProgressJS();
    this.headerinfo.pageLoadingDone(this);
    //   },

    //   (err: HttpErrorResponse) => {
    //     if (err.status === 0) {
    //       this.toastr.error("Unable to connect to server");
    //     }
    //     else if (err.status === 400) {
    //       this.toastr.error(err.error.message);
    //     }
    //     this.isFetchingData = false;
    //   }
    // );
  }
  // getUniqHTMLID(id:string){
  //   console.log(`id = ${id}${id}`);
  //   return `${id}${id}`;
  // }

  popconfirmdelete(show: number) {
    $('#deleteCourse').modal('show');
  }

  editModule() {
    //debugger;
    if (this.showModulePane) {
      this.showModulePane = false;
    } else {
      this.showModulePane = true;
    }
  }

  async deleteModule() {
    // this.headerinfo.pageLoadingStarted(this);

    // var proceed = confirm("You are about to delete Course. Are you sure you want to proceed?");
    // if (proceed) {
    $('#deleteCourse').modal('hide');

    await this.modulemanager.deleteModule(this.moduleInfo.id).toPromise();
    // (data: any) => {
    //this.addAdminError = null;
    // this.headerinfo.pageLoadingDone(this);

    this.toastr.success('Course Deleted');
    this.router.navigate(['user/usermodules']);
    //   },
    //   (err: HttpErrorResponse) => {
    //     if (err.status === 0) {
    //       this.toastr.error("Unable to connect to server");
    //     }
    //     else if (err.status === 400) {
    //       this.toastr.error(err.error.message);

    //     }
    //   }
    // );
    //}
  }

  getHTMLIDRef(id: string) {
    return `#collapse${id}`;
  }

  closemoduleeditor(toggle: boolean) {
    this.getModuleInfo();
    this.toastr.success('Edit Completed');
    this.editModule();
  }

  errormessage(error: any) {
    this.toastr.error(error);
  }

  gotoforum() {
    this.router.navigate(['user/forum'], {
      queryParams: { moduleid: this.moduleInfo.id },
    });
  }

  reloadlesson(lessons: any) {
    this.lessons = lessons;
  }

  displaysucessmsg(msg: any) {
    this.toastr.success(msg);
  }

  openPaymentWindow(url) {
    // this.paymentIframe.nativeElement.src = url;
    // $('#paymentDialog').modal('show');
    this.closePaymentWindow();
    this.paymentWindow = window.open(url);
  }

  closePaymentWindow() {
    //$('#paymentDialog').modal('hide');
    if (this.paymentWindow) {
      this.paymentWindow.close();
    }
    this.paymentWindow = null;
  }

  async enroll() {
    await this.modulemanager.enroll(this.allowBatches, this.selectedBatchId, this.moduleInfo.price, this.payments, this.toastr,
      this.moduleInfo.id, this.paymentWindow)
    
    if (this.moduleInfo.price <= 0) {
      await this.getModuleInfo();
    } 
    $('#popbatch').modal('hide');    
  }

  openenrolmodal() {
    $('#enrolstudents').modal('show');
  }
  closeEnrolModal() {
    $('#enrolstudents').modal('hide');
  }

  gotoUpcomingEvents() {
    this.router.navigate(['/events/view'], {
      queryParams: { moduleID: this.moduleInfo.id, isStudent: 1,classid:0 },
    });
  }

  async enrolstudent(file: any) {
    $('#enrolstudents').modal('hide');
    this.headerinfo.pageLoadingStarted(this);
    let totalfilesize = 0;
    //debugger
    let message: any = await this.modulemanager
      .uploadenrolfile(this.moduleID, file)
      .toPromise()
      .catch((err) => {
        this.toastr.error(err);
        this.headerinfo.pageLoadingDone(this);
        return;
      });
    this.headerinfo.pageLoadingDone(this);
    if (message) {
      this.toastr.success('Done');
      this.toastr.info(message.message);
      this.router.navigate(['/user/modulestudentlist'], {
        queryParams: { moduleid: this.moduleInfo.id },
      });
    }
    //window.location.reload();
  }

  formatNumber(_number: number) {
    return formatNumber(_number, this.locale);
  }

  async markCourseComplete() {
    try {
      this.headerinfo.pageLoadingStarted(this);

      const res: any = await this.modulemanager
        .markModuleCompleted(this.moduleInfo.id)
        .toPromise();
      if (res.completed) {
        this.toastr.success('Course completed.');
        if (res.courseCompletedMessage) {
          await this.util.alert(
            'Course Completed',
            res.courseCompletedMessage,
            true
          );
          if (res.certificateSent) {
            setTimeout(async () => {
              await this.util.alert(
                'Congratulations!!!',
                'Your completion certificate has been sent to your email'
              );
              try {
                document.getElementById('home-main-wrap').scrollTo(0, 0);
                document.getElementById('page-wrap').scrollTo(0, 0);
              } catch (error) {
                console.error(error);
              }
              document.location.reload();
            }, 500);
          }
        }
      } else {
        if (this.currentUserIsStudent) {
          // debugger;
          if (!res.allAssessmentsMarked) {
            this.toastr.warning(
              `Please wait for all your assessments to be marked`
            );
          } else {
            this.toastr.warning(
              `You did not meet the minimum passing score of ${this.moduleInfo.passScorePercentage}%. You got ${res.percentageScore}%`
            );
          }
        }
      }
    } catch (error) {
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }
  isExpierd(item: any) {
    if (new Date(item.inviteEndDate) > new Date()) {
      return false;
    }
    return true;
  }

  async popBatches() {
    this.moduleBatches = await this.modulemanager
      .getEnrollmentModuleBatches(this.moduleInfo.id)
      .toPromise();
    $('#popbatch').modal('show');
  }

  async submtEnroll() {
    if (this.allowBatches) {
      await this.popBatches();
    } else {
      this.enroll();
    }
  }

  openScormModal() {
    $('#scromupload').modal('show');
  }

  async uploadScrom(files: any){

    this.headerinfo.pageLoadingStarted(this);
    try {
      let formData = new FormData();
      formData.append('file', files[0]);
      formData.append('moduleId', this.moduleID);      
      await this.scormService.UploadScormFile(formData);
      this.headerinfo.pageLoadingDone(this);
      await this.getModuleInfo();
      this.toastr.success("Scrom import successfull");
    } catch (error) {
      this.headerinfo.pageLoadingDone(this);
    }
    finally {
    $('#scromupload').modal('hide');
    }
  }

  addProgressJS(){
    $( document ).ready(function() {

      $(".progress").each(function() {
    
        var value = $(this).attr('data-value');
        var left = $(this).find('.progress-left .progress-bar');
        var right = $(this).find('.progress-right .progress-bar');
    
        if (value > 0) {
          if (value <= 50) {
            right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)')
          } else {
            right.css('transform', 'rotate(180deg)')
            left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
          }
        }
    
      })
    
      function percentageToDegrees(percentage) {
    
        return percentage / 100 * 360
    
      }
    
    });
    
  }

  payFromModalPopUp(){
    if(this.moduleInfo.price > 0){
      this.submtEnroll()
    }
  }
}
